<div class="text-center mt-5 py-5 bg-white">
    <h1><i class="far fa-circle-xmark bad"></i></h1>

    <h1 class="pt-3">{{ 'view.error.oops' | translate }}</h1>

    <h2 class="pt-2">{{ errorMessage | translate }}</h2>

    <h3 class="pt-3">{{ description | translate }}</h3>
</div>